import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import rootReducer from './rootReducer'
import { userApi } from './api/user'
import combinedApiMiddleware from './middleware'


const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(combinedApiMiddleware),
})

// refetchOnFocus support: portal queries re-sync when the tab regains focus,
// so mutations done elsewhere (or missed invalidations) heal without a reload.
setupListeners(store.dispatch)


export default store